<!-- 获取授权商所有停车场信息内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
      return {
        requestBody: {

        },
        responseCode: {
          "data": {
            "parkList": [
              {
                "address": "广州市天河区",
                "desc": "",
                "eptCarports": 100,
                "latitude": "50.127",
                "longitude": "11.316542",
                "parkCode": "2KKJCP36",
                "parkName": "商务大厦",
                "totalCarports": 500
              }
            ],
            "total": 1
          },
          "message": "业务成功",
          "resultCode": 0,
          "status": 1
        },
        infoData: {
          explain: "第三方接入系统请求智慧停车开放平台获取授权商所有停车场信息内容",
          t_url: this.commonUrls.test+"getParkList",
          p_url: this.commonUrls.prod+"getParkList",
          precondition: "无",
          fitSystem: "VEMS传统停车场, 云停车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'total', info2: '是', info3: 'Integer', info4: '记录总数' },
              { info1: 'parkList', info2: '是', info3: 'JSONArray', info4: '停车场列表' }
            ]
          },{
            titleName: 'parkList',
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
              { info1: 'address', info2: '是', info3: 'String', info4: '停车场地址' },
              { info1: 'desc', info2: '是', info3: 'String', info4: '描述' },
              { info1: 'eptCarports', info2: '是', info3: 'Integer', info4: '空车位数' },
              { info1: 'latitude', info2: '是', info3: 'String', info4: '纬度' },
              { info1: 'longitude', info2: '是', info3: 'String', info4: '经度' },
              { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
              { info1: 'totalCarports', info2: '是', info3: 'String', info4: '总车位数' },
            ]
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
            td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/park/getParkList.vue